import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminUserListLoader = async () => {

    const response = await networkCall('/users');

    return !response ? null : response;

};